
import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";


const instance = axios.create({
    baseURL: BASE_URL,

  withCredentials: true,
});

const refreshClient = axios.create({
  baseURL: instance.defaults.baseURL,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("jwt_token");
    if (token && config && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

let isRefreshing = false;
let refreshSubscribers: Array<(token: string) => void> = [];

function onRefreshed(token: string) {
  refreshSubscribers.forEach((cb) => cb(token));
  refreshSubscribers = [];
}

function addRefreshSubscriber(cb: (token: string) => void) {
  refreshSubscribers.push(cb);
}

async function refreshAccessToken(): Promise<string> {
  const refreshToken = localStorage.getItem("refresh_token");


  if (!refreshToken) {
    throw new Error("No refresh token available");
  }

  

  const response = await refreshClient.post("/api/token/refresh", {
    refresh_token: refreshToken,
  });

 
 
 
  
  const newToken = response.data?.token;
const newRefreshToken = response.data?.refresh_token;

if (newRefreshToken) {
  localStorage.setItem("refresh_token", newRefreshToken);
}
  if (!newToken) throw new Error("No token returned from refresh endpoint");

  localStorage.setItem("jwt_token", newToken);
  return newToken;
}

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const { config, response } = error as any;
    if (!response || !config) return Promise.reject(error);

    if (response.status === 401 && !config._retry) {
      config._retry = true;

      if (isRefreshing) {
        return new Promise((resolve) => {
          addRefreshSubscriber((token: string) => {
            if (config.headers) config.headers.Authorization = `Bearer ${token}`;
            resolve(instance(config));
          });
        });
      }

      isRefreshing = true;

      return new Promise(async (resolve, reject) => {
        try {
          const newToken = await refreshAccessToken();
          isRefreshing = false;
          onRefreshed(newToken);

          if (config.headers) config.headers.Authorization = `Bearer ${newToken}`;
          resolve(instance(config));
        } catch (err) {
          isRefreshing = false;

          localStorage.removeItem("jwt_token");
          localStorage.removeItem("refresh_token");

          try {
            window.location.href = "/auth";
          } catch (e) {

          }
          reject(err);
        }
      });
    }

    return Promise.reject(error);
  }
);

export default instance;
